import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from './Services/AppService/app.service';
import {  SET_ACTIVE_LOCATION_ACTION, SIGN_IN_ACTION } from './store/app.action';
import { LoadPixelAdService, WebsiteAttributesService } from 'imakeapp-shared';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit
{

  loader: boolean = true;
  theme_data = {
    logo: ''
  };


  constructor(
    private cookie_s: CookieService,
    private store: Store,
    private analytics_loading_s: LoadPixelAdService,
    private webattrService: WebsiteAttributesService,
    private app_service: AppService
  ){}


  async ngOnInit()
  {

    this.fetch_site_attributes();

    this.set_init_states();

    this.analytics_load();

  }



  fetch_site_attributes()
  {




     this.get_theme_data();


  }



  analytics_load()
  {

    this.analytics_loading_s.InitGoogleAnalytics('G-878K8ZPKGF');
    this.analytics_loading_s.InitFacebookPixel('781651733466387');
    this.analytics_loading_s.InitTiktokPixel('CHRIDKJC77U0O25EQ2C0');

  }








  set_init_states()
  {
this.cookie_s.set("lang","en")
    if ( this.cookie_s.get('user') )
    {
      this.store.dispatch( new SIGN_IN_ACTION( JSON.parse(this.cookie_s.get('user')) ) );
    }

    if ( this.cookie_s.get('location') )
    {
      this.store.dispatch( new SET_ACTIVE_LOCATION_ACTION( JSON.parse(this.cookie_s.get('location')) ) );
    }

  }








  get_theme_data()
  {

    this.app_service.get_site_theme().subscribe(
      (response : any)=>{

        if ( !Object.keys(response).length  ) return;


        // set theme data
        this.set_theme_data(response);


      },
      (err: any)=>{
        console.error(err);
      }
    );

  }



  set_theme_data(website_attributes: any)
  {

    this.theme_data.logo = website_attributes['logo'];

  }






}
